import React from "react";

const Bills = (props) => {
  return (
    <svg
      viewBox="0 0 18 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.1597 20.5248H1.84037C0.969474 20.5248 0.256348 19.8117 0.256348 18.9408V2.05924C0.256348 1.18835 0.969474 0.47522 1.84037 0.47522H16.1597C17.0306 0.47522 17.7437 1.18835 17.7437 2.05924V18.9408C17.7437 19.8117 17.0306 20.5248 16.1597 20.5248ZM1.84037 1.89516C1.75202 1.89516 1.67629 1.97089 1.67629 2.05924V18.9408C1.67629 19.0291 1.75202 19.1049 1.84037 19.1049H16.1597C16.2481 19.1049 16.3238 19.0291 16.3238 18.9408V2.05924C16.3238 1.97089 16.2481 1.89516 16.1597 1.89516H1.84037Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.2"
      />
      <path
        d="M13.7417 5.27777H4.22488C3.83361 5.27777 3.51807 4.96222 3.51807 4.57095C3.51807 4.17968 3.83361 3.86414 4.22488 3.86414H13.7417C14.1329 3.86414 14.4485 4.17968 14.4485 4.57095C14.4485 4.96222 14.1329 5.27777 13.7417 5.27777Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.2"
      />
      <path
        d="M9.526 10.3515H4.22488C3.83361 10.3515 3.51807 10.036 3.51807 9.64468C3.51807 9.25341 3.83361 8.93787 4.22488 8.93787H9.526C9.91727 8.93787 10.2328 9.25341 10.2328 9.64468C10.2328 10.036 9.91727 10.3515 9.526 10.3515Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.2"
      />
      <path
        d="M9.526 13.7343H4.22488C3.83361 13.7343 3.51807 13.4188 3.51807 13.0275C3.51807 12.6362 3.83361 12.3207 4.22488 12.3207H9.526C9.91727 12.3207 10.2328 12.6362 10.2328 13.0275C10.2328 13.4188 9.91727 13.7343 9.526 13.7343Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.2"
      />
      <path
        d="M9.526 17.1169H4.22488C3.83361 17.1169 3.51807 16.8013 3.51807 16.4101C3.51807 16.0188 3.83361 15.7032 4.22488 15.7032H9.526C9.91727 15.7032 10.2328 16.0188 10.2328 16.4101C10.2328 16.8013 9.91727 17.1169 9.526 17.1169Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.2"
      />
      <path
        d="M13.7413 10.3515H12.2014C11.8102 10.3515 11.4946 10.036 11.4946 9.64468C11.4946 9.25341 11.8102 8.93787 12.2014 8.93787H13.7413C14.1326 8.93787 14.4481 9.25341 14.4481 9.64468C14.4481 10.036 14.1326 10.3515 13.7413 10.3515Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.2"
      />
      <path
        d="M13.7413 13.7343H12.2014C11.8102 13.7343 11.4946 13.4188 11.4946 13.0275C11.4946 12.6362 11.8102 12.3207 12.2014 12.3207H13.7413C14.1326 12.3207 14.4481 12.6362 14.4481 13.0275C14.4481 13.4188 14.1326 13.7343 13.7413 13.7343Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.2"
      />
      <path
        d="M13.7413 17.1169H12.2014C11.8102 17.1169 11.4946 16.8013 11.4946 16.4101C11.4946 16.0188 11.8102 15.7032 12.2014 15.7032H13.7413C14.1326 15.7032 14.4481 16.0188 14.4481 16.4101C14.4481 16.8013 14.1326 17.1169 13.7413 17.1169Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.2"
      />
    </svg>
  );
};

export default Bills;
